import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header cursor-pointer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Payment information")
], -1)
const _hoisted_4 = { class: "d-grid gap-2 d-md-flex justify-content-md-end" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle me-2"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_8 = { class: "card-body p-9" }
const _hoisted_9 = { class: "row mb-7" }
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "form-check form-switch ms-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "taxCheckbox"
}, "I have Tax ID", -1)
const _hoisted_13 = { class: "col-lg-4" }
const _hoisted_14 = {
  key: 0,
  class: "form-check form-switch ms-3"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "danishCheckbox"
}, "I have a Danish bank account", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaxIDInputs = _resolveComponent("TaxIDInputs")!
  const _component_DanishAccountInputs = _resolveComponent("DanishAccountInputs")!
  const _component_SwiftIbanInputs = _resolveComponent("SwiftIbanInputs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mutateChildProp && _ctx.mutateChildProp(...args))),
          disabled: _ctx.isSaving,
          class: "d-flex align-items-center btn btn-sm btn-success align-self-center"
        }, [
          (_ctx.isSaving)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6))
            : _createCommentVNode("", true),
          _hoisted_7
        ], 8, _hoisted_5),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('discard'))),
          class: "btn btn-sm btn-danger align-self-center"
        }, " Discard ")
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "taxCheckbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.hasTaxId) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.hasTaxId]
            ]),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (!_ctx.hasTaxId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "danishCheckbox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.hasDanishAccount) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.hasDanishAccount]
                ]),
                _hoisted_15
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.hasTaxId)
        ? (_openBlock(), _createBlock(_component_TaxIDInputs, {
            key: 0,
            emitData: _ctx.takeDataFromChild,
            onSaveData: _ctx.saveData
          }, null, 8, ["emitData", "onSaveData"]))
        : (_ctx.hasDanishAccount)
          ? (_openBlock(), _createBlock(_component_DanishAccountInputs, {
              key: 1,
              emitData: _ctx.takeDataFromChild,
              onSaveData: _ctx.saveData
            }, null, 8, ["emitData", "onSaveData"]))
          : (_openBlock(), _createBlock(_component_SwiftIbanInputs, {
              key: 2,
              emitData: _ctx.takeDataFromChild,
              onSaveData: _ctx.saveData
            }, null, 8, ["emitData", "onSaveData"]))
    ])
  ]))
}